import homePage from "../../Images/chess-hids-home-page.png";
import loginPage from "../../Images/chess-hids-login-page.png";

const GettingStarted = () => {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-3xl font-semibold text-blue-800 mb-6">
        Getting Started
      </h1>

      <b> System Requirements</b>
      <p>
        Before installing HIDS, ensure your system meets the following
        requirements:
      </p>
      <ol className="flex flex-col gap-4">
        <li>
          <b>Operating System:</b> Linux, Windows, or macOS
        </li>
        <li>
          <b> Processor: </b> Minimum 2GHz Dual-Core CPU
        </li>
        <li>
          <b>RAM:</b> At least 4GB
        </li>
        <li>
          <b>STORAGE: </b> Minimum 20GB free disk space
        </li>
        <li>
          <b>Network:</b> Internet connection required for updates and remote
          monitoring
        </li>
      </ol>

      <b>
        Follow these steps to successfully log in to Chess-HIDS through the Sign
        In button:
      </b>
      <ul className="flex flex-col gap-4 list-disc">
        <li> Open the Chess HIDS Website</li>
        <li className="ml-6 list-none text-blue-500">
          {" "}
          <a href="https://chess-hids.securweave.com/" target="blank">
            {" "}
            https://chess-hids.securweave.com/
          </a>
        </li>
        <li>
          Using above URL Navigate to the Chess-HIDS homepage in your web
          browser.
        </li>
        <li> Locate the Sign In Button</li>
        <img src={homePage} className="size-2/3" />
        <li>
          On the top-right corner of the homepage, you'll see a Sign In button
          next to the Sign Up option.
        </li>

        <li> Click on the Sign In button to proceed to the login page.</li>
      </ul>

      <b> Enter Your Credentials</b>
      <p>
        You will be redirected to the login page where you'll be asked to enter
        your credentials:
      </p>
      <ul className="flex flex-col gap-4 list-disc ml-6">
        <li>
          Username: Input the registered username associated with your ChessHIDS
          account.
        </li>
        <li> Password: Enter your secure password.</li>
        <img src={loginPage} className="size-2/3" />
        <li> Submit the Login Form</li>
      </ul>
    </div>
  );
};

export default GettingStarted;
